<div class="margin-top-16"
    *ngIf="(noPOSSolution() || canHandlePayments()) && ((paymentHistory && paymentHistory.length > 0) || invoice.ExternalKey)">
    <div class="label header">{{'bikeshop.rentals.booking.payment_status' | translate}}</div>
    <div class="payment-history-container">
        <div class="header">
            <div class="sync-status">
                <span style="width: 21px"></span>
            </div>
            <div>{{ 'bikeshop.rentals.booking.payment_method' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.payment_date' | translate }}</div>
            <div style="flex: 1.5">{{ 'bikeshop.rentals.booking.identifier' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.payment_amount' | translate }}</div>
            <div style="flex: 1.5" *ngIf="hasRefund">{{ 'bikeshop.rentals.booking.refunds' | translate }}</div>
        </div>

        <div *ngFor="let payment of paymentHistory">
            <div class="sync-status">
                <span class="hubtiger-pos-sent" *ngIf="payment.paymentSentToPOS"></span>
                <span class="hubtiger-pos-not-sent" *ngIf="!payment.paymentSentToPOS"></span>
            </div>
            <div>{{payment.paymentMethod}}</div>
            <div>{{(payment.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
            <div style="flex: 1.5">{{payment.paymentMethod === 'STRIPE' || payment.paymentMethod === 'STRIPE-APP' || payment.paymentMethod === 'PAYSTACK' ?
                payment.stripePaymentIntent : '' }}</div>
            <div>{{partner.CurrencySymbol}}{{payment.amountPaid.toFixed(2)}}</div>
            <div style="flex: 1.5" *ngIf="hasRefund">
                <div *ngFor="let refund of payment.refunds" class="refund">
                    <div>{{partner.CurrencySymbol}}{{refund.amountRefunded.toFixed(2)}}</div>
                    <div>{{(refund.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="busySyncing || busyLoading" style="margin-top: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="sync-button-container row" *ngIf="(invoice && invoice.ExternalKey && canHandlePayments()) || canRefund">
        <div class="col-md-2"></div>
        <div class="col-md-4">
            <button pButton type="button" *ngIf="canRefund" class="p-button-raised full-width accent"
                (click)="initiateRefund()" label="{{'bikeshop.rentals.booking.initiate_refund'| translate}}"></button>
        </div>
        <div class="col-md-4">
            <button pButton type="button" *ngIf="invoice && invoice.ExternalKey && canHandlePayments()" [disabled]="busySyncing || busyLoading" class="p-button-raised full-width"
                (click)="syncPayments()" label="{{'bikeshop.rentals.booking.sync_payments'| translate}}"></button>
        </div>
    </div>

</div>

<p-dialog header="{{ 'bikeshop.rentals.booking.initiate_refund' | translate }}"
          [(visible)]="showInitiateRefundDialog" 
          [modal]="true" 
          [responsive]="true" 
          [style]="{width: '600px', 'padding': '32px'}"
                    
          [contentStyle]="{'overflow':'visible', 'height': 'inherit'}" 
          *ngIf="showInitiateRefundDialog">
    <app-initiate-service-payment-refund [payments]="paymentHistory" [partner]="partner" [countryData]="countryData" (refundComplete)="refundComplete()"></app-initiate-service-payment-refund>
</p-dialog>
<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>